import React, { useEffect, useState } from "react";
import { Typography, Box, Modal, Divider, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import BackdropImage from "../../Images/Universal/Login.png";
import { useTranslation } from "react-i18next";

function MoadalOldUI({
  showModal,
  setshowModal,
  destination,
  callNow,
  price,
  customerName,
  comment,
  setcustomerName,
  setcomment,
  paymentType,
  setPaymentType,
}) {
  // 1) Data
  const { t } = useTranslation();
  const ApplicationSettings = useSelector(
    (state) => state.ApplicationSettings.value
  );
  const [callType, setcallType] = useState(0);

  // 2) useEffect
  useEffect(() => {
    try {
      findCallType();
    } catch (error) {
      console.log("Error :", error);
    }

    return;
  }, []);

  // 3) Function
  async function findCallType() {
    let calltype = 0;

    //Find if destination exist in Buttons Arrat
    let index = await find_object();

    if (index != undefined) {
      calltype = index.callType;
    }

    setcallType(calltype);
  }

  function find_object() {
    let dest = destination;

    //Find if destination exist in Buttons Arrat
    let index = ApplicationSettings.ButtonsArray.filter(
      (item) => item.name == dest
    )[0];

    if (index == undefined) {
      index = ApplicationSettings.Extra_Destinations_Array.filter(
        (item) => item.name == dest
      )[0];
    }

    return index;
  }

  return (
    <>
      <Modal
        open={showModal}
        onClose={() => {
          setshowModal(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="p-10 h-full" style={{ backgroundImage: BackdropImage }}>
          <Box sx={style} className="GlassEffectModal">
            <div className="p-5"></div>

            {/* Main section */}
            <div className="px-2">
              <div className="text-center mt-0">
                <div className=" flex justify-center items-center mt-1 ">
                  {/* <ArrowForwardIcon className="m-1" /> */}
                  <p className="text-2xl text-gray-700 font-semibold">
                    {" " + destination}
                  </p>
                </div>
              </div>

              <div className="p-2">
                <Grid container mb={1}>
                  <>
                    <Grid container mb={1} className="justify-center ">
                      <Typography className="text-center justify-center">
                        {t("Σίγουρα_θέλετε_να_καλέσετε_ένα_ταξί_τώρα_για")}
                      </Typography>
                    </Grid>
                    <Grid container className="justify-center ">
                      <Typography className=" justify-center">
                        {" " + destination}
                      </Typography>
                    </Grid>
                    {ApplicationSettings.ShowPrices && (
                      <>
                        <Grid container className="justify-center ">
                          {price?.price != undefined && (
                            <Typography className=" justify-center">
                              {t("Κόστος_διαδρομής")}
                              {" : " +
                                price?.price +
                                ApplicationSettings.currencySymbol}
                            </Typography>
                          )}
                        </Grid>
                        <Grid container className="justify-center ">
                          {price?.priceNight != undefined && (
                            <Typography className=" justify-center">
                              {t("Κόστος_διαδρομής_νύχτα")}
                              {" : " +
                                price?.priceNight +
                                ApplicationSettings.currencySymbol}
                            </Typography>
                          )}
                        </Grid>
                      </>
                    )}
                    <Grid container className="justify-center ">
                      <Typography className=" justify-center">
                        {customerName != ""
                          ? t("Customer") + " : " + customerName
                          : ""}
                      </Typography>
                    </Grid>
                    {/* <Grid container className="justify-center ">
                      <Typography className=" justify-center">
                        {t("POS_Payment")}
                        {paymentType === true
                          ? " : " + t("YES")
                          : " : " + t("NO")}
                      </Typography>
                    </Grid> */}
                    <Grid container mb={1} className="justify-center ">
                      <Typography className=" justify-center">
                        {comment != "" ? t("Comment") + " : " + comment : ""}
                      </Typography>
                    </Grid>
                  </>
                </Grid>
              </div>
            </div>

            {/* Buttons */}
            <div className="p-4"></div>
            <Divider />
            <Grid container className="text-center">
              <Grid
                item
                xs={6}
                className="flex  Primary_Main_Background text-gray-700 justify-center items-center p-4 cursor-pointer rounded-bl-md"
                onClick={() => {
                  callNow(
                    destination,
                    customerName,
                    comment,
                    paymentType,
                    callType
                  );
                  setcustomerName("");
                  setcomment("");
                  setshowModal(false);
                  setPaymentType(false);
                }}
              >
                <p className="font-semibold w-full h-full hover:scale-125  ">
                  {t("YES")}
                </p>
              </Grid>
              <Grid
                item
                xs={6}
                onClick={() => setshowModal(false)}
                className="flex  Primary_Dark_Background Primary_Light_Text justify-center items-center p-4 cursor-pointer rounded-br-md"
              >
                <p className="font-semibold w-full h-full hover:scale-125 ">
                  {t("NO")}
                </p>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Modal>
    </>
  );
}

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  maxWidth: 550,
  borderRadius: 2,
  boxShadow: 24,
  //background: "#fff",
};

export default MoadalOldUI;
